import { component$, Slot } from "@builder.io/qwik";
import { cn } from "~/lib/cn";

interface SubheadingProps {
  as?: "h2" | "h3" | "h4" | "h5" | "h6" | "p";
  class?: string;
}

export const Subheading = component$<SubheadingProps>(
  ({ as: Tag = "h2", ...props }) => {
    return (
      <Tag
        class={cn(
          "mb-6 text-2xl font-semibold text-gray-800 dark:text-gray-200",
          props.class,
        )}
      >
        <Slot />
      </Tag>
    );
  },
);

export default Subheading;
